// extracted by mini-css-extract-plugin
module.exports = {"container":"elements-module--container--1wVin","row":"elements-module--row--PxsNC"};